<template>
  <div id="form2">
    <h2>Lückentext</h2>
    <br><br>
    <p style="text-align: left;">
        Professor Möller erklärt in seiner Vorlesung, weshalb elektronische Geräte zur Verarbeitung von Audiosignalen in einem begrenzten Pegelbereich konzipiert sind.
        Dabei wird erklärt, 
    </p>
    <p style="text-align: left;">
        dass der Headroom den Bereich zwischen dem <input v-model="message3" placeholder="Feld1" /> 
        (auch ‘Nennpegel’) und dem <input v-model="message4" placeholder="Feld2" /> trennt,den ein Audiogerät verarbeiten kann. Sie bildet die Differenz. 
    </p>
    <p style="text-align: left;">
        Alle Signalwerte, die den Maximalen darstellenden Bereich überschreiten, gelangen in den Aussteuerungsbereich (= <input v-model="message5" placeholder="Feld3" />).
    </p>
    <p style="text-align: left;">
        Der Footroom bildet das untere Ende des Aussteuerungsbereich und bildet die Begrenzung, um das Rauschen nicht hörbar werden zu lassen. 
        Kommt es zu niedrigen Signalwerten, kommt es zur Untersteuerung (= <input v-model="message6" placeholder="Feld4" />).
    </p>
    <p style="text-align: left;">
        Signale, die sich im Bereich zwischen dem Foot- und Headroom bewegen, liegen im Dynamikbereich. In diesem Bereich wird die Gefahr von Verzerrungen minimiert, 
        und das <input v-model="message7" placeholder="Feld5" /> überspielt - ein optimaler Sound ist zu erwarten.
    </p>

    <button id="button3" v-on:click="check2">
        Prüfen
    </button>

  </div>
</template>
<script>

export default {
  name: "two-lists",
  display: "Two Lists",
  order: 1,

  data() {
    return {
        message3: '',
        message4: '',
        message5: '',
        message6: '',
        message7: '',
    }
  },
  methods: {
    log: function(evt) {
      window.console.log(evt);
    },
    check2() {
        if ( (this.message3 && this.message3 == "Bezugspegel" || this.message3 == "bezugspegel") &&
             (this.message4 && this.message4 == "Maximalpegel" || this.message4 == "maximalpegel") &&
             (this.message5 && this.message5 == "Clipping" || this.message5 == "clipping") &&

             ((this.message6 && this.message6 == "Schlechter SNR" || this.message6 == "schlechter SNR") ||
             (this.message6 && this.message6 == "Schlechte SNR" || this.message6 == "schlechte SNR") ||
             (this.message6 && this.message6 == "Schlechter Signal-to-Noise Ratio" || this.message6 == "schlechter signal-to-noise ratio") ||
             (this.message6 && this.message6 == "Schlechte Signal-to-Noise Ratio" || this.message6 == "schlechte signal-to-noise ratio")) &&

             (this.message7 && this.message7 == "Grundrauschen" || this.message7 == "grundrauschen")
            ){
                alert("richtig");
                this.$store.commit('setTaskCompletionState', {varname: "audioForm2_done", state: true})
                localStorage.setItem("audioFor2m_done", true);
            }
        else {
            alert("falsch")
        }
    }
  }
};
</script>

<style scoped>
/* #input1 {
    position: absolute;
    left: 260px;
    top: 305px
} */
/* #input2 {
    position: absolute;
    left: 530px;
    top: 205px
} */
#button3 {
    position: absolute;
    left: 650px;
    top: 550px;
    font-family: sans-serif;
    font-size: 20px;
    /* background-color: #297; */
    color: #fff;
    border: 0px;
    border-radius: 3px;
    padding: 20px;
    cursor: pointer;
    margin-bottom: 20px;
    background-color: #528382
}
#form2 {
    height: 1000px;;
}
</style>